import axios from 'axios';
import config from '../config/configuration.js';
import AuthenticationService from './AuthenticationService';

const authenticationService = new AuthenticationService();

export default class NoticeService {

	findNotices() {
		let url = `${config.serverPath}/notices`;
		return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	findNotice(_id) {
        let url = `${config.serverPath}/notices/${_id}`;
		return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	addNotice(notice) {
		let url = `${config.serverPath}/notices`;
		return axios.post(url, notice, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	updateNotice(_id, notice) {
		let url = `${config.serverPath}/notices/${_id}`;
		return axios.put(url, notice, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	deleteNotice(_id) {
		let url = `${config.serverPath}/notices/${_id}`;
		return axios.delete(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	addAttachment(formData, noticeId) {
		let url = `${config.serverPath}/notices/attachment/${noticeId}`;
		return axios.post(url, formData, { 
			headers: {
				...authenticationService.authHeader(),
				'Content-Type': 'multipart/form-data'
			}
		}).then(res => res.data);
	}

	deleteAttachment(noticeId, attachementId) {
		let url = `${config.serverPath}/notices/attachment/${noticeId}/${attachementId}`;
		return axios.delete(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	attachmentUrl(noticeId, attachementId) {
        return `${config.serverPath}/notices/attachment/${noticeId}/${attachementId}`;
	}
	
}